import { useState, useEffect, useContext } from "react"
import { TbUsers } from "../../components/tables/TbUsers"
import { ContextApp } from "../../context/ContextApp"
import { validateUsers } from "../../helpers/validateForms"

import Titulo from "../../components/titles/Titulo"
import InputSearch from "../../components/inputs/inputs/InputSearch"
import InputJim from "../../components/inputs/inputs/InputJim"
import SelectJim from "../../components/inputs/inputs/SelectJim"
import ModalConfirm from "../../components/ModalComfirm/ModalConfirm"

import '../pageStyles.css'
import './users.css'

const Users = () => {

  const initialErrors = {
    nombre: '',
    password: '',
    alias: '',
    nivel: '',
  }

  const { loginUp, niveles, token, refreshToken, usuario } = useContext(ContextApp);

  const [user, setUser] = useState(usuario)
  const [users, setUsers] = useState([])
  const [usersFiltred, setUsersFiltred] = useState([])
  const [showForm, setShowForm] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState(initialErrors);

  useEffect(() => {
    const loadData = async () => {
      try {
        await refreshToken();
        const data = await usuario.getUsers();
        setUsers(await data);
        setUsersFiltred(await data);
      } catch (error) {
        console.log(error.message)
      }
    }
    loadData();
  }, [usuario, loginUp, refreshToken])

  const filterData = (data) => {
    const newData = users.filter((user) => user.USE_NOMBRE.toLowerCase().includes(data.toLowerCase()))
    setUsersFiltred(newData)
  }

  const handleChange = (name, value) => {
    setUser({ ...user, [name]: value })
  }
  const validateData = async (name, value) => {
    const error = await validateUsers(name, value)
    setErrors(prevErrors =>{
        return {...prevErrors, [name]:error}
      })
  }

  const sendForm = async () => {
    try {
      await refreshToken()

      await validateData('nombre', user.nombre)
      await validateData('password', user.password)
      await validateData('alias', user.alias)

      if (user.nombre.length > 2 
        && user.password.length > 2
        && user.alias.length === 3 ) {
        setUsersFiltred(await usuario.addUser(user, token))
        setShowForm(false)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  const deleteUser = async (e) => {
    setShowModal(!showModal)

    await refreshToken()

    const data = await usuario.delUser(user.USE_CLAVE, token)
    setUsersFiltred(data)
    setUser(usuario)
  }
  const showPopup = (e) => {
    setUser(e)
    setShowModal(!showModal)
  }

  return (
    <>
    <div className="container-data">

      <section className="data-body">

        <section className="data-header">
          <Titulo>Usuarios</Titulo>

          <InputSearch
            placeholder='título a buscar'
            onChange={filterData} />
          <button className="material-icons-outlined btn" onClick={() => setShowForm(!showForm)}>add</button>
        </section>
        {users &&
          <section className="data-table">

            <TbUsers
              users={usersFiltred}
              // updateUser={updateUser}
              deleteUser={showPopup}
              items={users} />

          </section>
        }
      </section>

      <section className="data-edit">
        {showForm &&
          <section className="data-form">

            <InputJim classN='span'
              type='text'
              name='nombre'
              value={user.nombre}
              onChange={handleChange}
              onBlur={validateData}
              placeholder='escribe nombre'
              error={errors.nombre} />
            <InputJim classN='span'
              type='text'
              name='password'
              value={user.password}
              onChange={handleChange}
              onBlur={validateData}
              placeholder='escribe password'
              error={errors.password} />
            <InputJim
              type='text'
              name='alias'
              value={user.alias}
              onChange={handleChange}
              onBlur={validateData}
              placeholder='escribe alias'
              error={errors.alias} />
            <SelectJim
              name='nivel'
              value={user.nivel}
              onChange={handleChange}
              items={niveles}
              error='' />


            <button className="btn posButton" onClick={sendForm}>ENVIAR</button>
          </section>
        }
        <div className={showForm ? "data-logo hidden" : "data-logo"} />
      </section>

    </div>

    {showModal &&
  <ModalConfirm title='Confirmar eliminación' showPopup={showPopup}>
    <>
      <section className='modal-message'>
        <h2>Vas a eliminar al usuario</h2>
        <h2> {user.USE_NOMBRE} </h2>
      </section>
      <section className='modal-buttons'>
        <button onClick={deleteUser}>ACEPTAR</button>
        <button onClick={showPopup}>CANCELAR</button>
      </section>
    </>
  </ModalConfirm>
}
</>

  )
}
export default Users